import cx from 'classnames';
import { IModalProps, Modal } from 'components/ui/Modal';
import _ from 'lodash';
import type { ElementType, ReactNode } from 'react';
import css from './ConfirmationModalV2.module.scss';

export interface IConfirmationModalV2Props extends IModalProps {
  children: ReactNode;
  isVisible: boolean;
  onClose: () => void;
}

const ConfirmationModalV2 = ({
  centered = true,
  className,
  isVisible,
  onClose,
  ...rest
}: IConfirmationModalV2Props) => (
  <Modal
    backdropClassName={css.backdrop}
    centered={centered}
    className={cx(css.modal, className)}
    hasCloseButton={false}
    keyboard={false}
    onHide={onClose}
    show={isVisible}
    {...rest}
  />
);

export interface IConfirmationProps {
  heading: string;
  details: ReactNode | string[];
}

const Confirmation = ({ heading, details }: IConfirmationProps) => (
  <div className={css.confirmation}>
    <h1>{heading}</h1>
    <div className={css.details}>
      {_.isArray(details)
        ? details.map((detail, index) => <p key={index}>{detail}</p>)
        : details}
    </div>
  </div>
);

export interface IIconProps {
  color: 'gray' | 'red' | 'yellow' | 'blue';
  icon: ElementType;
}

const Icon = ({ color, icon: Component }: IIconProps) => (
  <div className={cx(css.icon, css[color])}>
    <Component height={36} width={36} />
  </div>
);

ConfirmationModalV2.Body = Modal.Body;
ConfirmationModalV2.Confirmation = Confirmation;
ConfirmationModalV2.Footer = Modal.Footer;
ConfirmationModalV2.Header = Modal.Header;
ConfirmationModalV2.Icon = Icon;

export { ConfirmationModalV2 };
